import React, { Component } from "react";

class AISimilaritiesAnalysis extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      tooltipStyle: {}
    };
  }

  showTooltip = e => {
    const rect = e.currentTarget.getBoundingClientRect();
    const tooltipWidth = 420;
    const padding = 12;

    let left = rect.left + rect.width / 2 - tooltipWidth / 2;

    // clamp inside viewport
    left = Math.max(
      padding,
      Math.min(left, window.innerWidth - tooltipWidth - padding) + 5
    );

    this.setState({
      tooltipStyle: {
        top: rect.top - 197,
        left
      },
      show: true
    });
  };

  hideTooltip = () => {
    this.setState({ show: false });
  };

  render() {
    const { show, tooltipStyle } = this.state;

    return (
      <span
        className="sparkle-wrapper"
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
      >
        {this.props.children}

        {show && (
          <div className="ai-hover-modal fixed" style={tooltipStyle}>
            {this.props.tooltipContent}
            <div className="ai-arrow top" />
          </div>
        )}
      </span>
    );
  }
}

export default AISimilaritiesAnalysis;
